<script>
    export let bgColor = 'bg-slate-400';
    export let title = 'Card Title';
    export let text = 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore.';
    export let buttonText = 'Weiterlesen...';
    export let buttonHref = '';
</script>


<div class="flex justify-center">
    <div class="block p-6 rounded-md shadow-lg {bgColor} max-w-sm">
    <h5 class="text-slate-900 text-xl leading-tight font-medium mb-2">{title}</h5>
    <p class="text-slate-700 text-base mb-4">{text}</p>
    <button type="button" onclick="location.href='{buttonHref}'" class="inline-block px-6 py-2.5 bg-slate-50 text-slate-600 font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-slate-200 hover:shadow-lg focus:bg-slate-300 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-slate-300 active:shadow-lg transition duration-150 ease-in-out">{buttonText}</button>
    </div>
</div>
